import React from 'react';

const branches = [
  { d: 'M16,52 L16,36', delay: '0s' },
  { d: 'M16,36 L16,24', delay: '0.08s' },
  { d: 'M16,38 L7,30', delay: '0.13s' },
  { d: 'M16,38 L25,30', delay: '0.13s' },
  { d: 'M7,30 L1.5,22', delay: '0.2s' },
  { d: 'M7,30 L9,21.5', delay: '0.2s' },
  { d: 'M25,30 L30.5,22', delay: '0.2s' },
  { d: 'M25,30 L23,21.5', delay: '0.2s' },
  { d: 'M16,24 L11,11', delay: '0.25s' },
  { d: 'M16,24 L21,11', delay: '0.25s' },
];

const leaves = [
  { d: 'M1.5,22 m0,-5 l2.6,5 l-2.6,5 l-2.6,-5 Z', fill: '#ff3ea5', delay: '0.34s' },
  { d: 'M9,21.5 m0,-5 l2.6,5 l-2.6,5 l-2.6,-5 Z', fill: '#c46bff', delay: '0.38s' },
  { d: 'M30.5,22 m0,-5 l2.6,5 l-2.6,5 l-2.6,-5 Z', fill: '#ff3ea5', delay: '0.42s' },
  { d: 'M23,21.5 m0,-5 l2.6,5 l-2.6,5 l-2.6,-5 Z', fill: '#c46bff', delay: '0.46s' },
  { d: 'M11,11 m0,-5 l2.6,5 l-2.6,5 l-2.6,-5 Z', fill: '#c46bff', delay: '0.5s' },
  { d: 'M21,11 m0,-5 l2.6,5 l-2.6,5 l-2.6,-5 Z', fill: '#ff3ea5', delay: '0.54s' },
];

const TreeLogo = ({ gradientId = 'zk-logo-grad', style }) => (
  <svg
    viewBox="0 0 56 54"
    style={{
      position: 'absolute',
      left: '-13px',
      top: '-24px',
      width: '56px',
      height: '54px',
      overflow: 'visible',
      pointerEvents: 'none',
      zIndex: 0,
      ...style,
    }}
    aria-hidden="true"
  >
    <defs>
      <linearGradient id={gradientId} x1="0" y1="1" x2="0.4" y2="0">
        <stop offset="0" stopColor="#38e0ff" />
        <stop offset="1" stopColor="#ff3ea5" />
      </linearGradient>
    </defs>
    <g fill="none" stroke={`url(#${gradientId})`} strokeWidth="1.15" strokeLinecap="round" strokeLinejoin="round">
      {branches.map((b, i) => (
        <path
          key={i}
          data-zk-tw
          d={b.d}
          style={{ strokeDasharray: 60, transitionDelay: b.delay }}
        />
      ))}
    </g>
    <g>
      {leaves.map((l, i) => (
        <g key={i} data-zk-lf style={{ transitionDelay: l.delay }}>
          <path d={l.d} fill={l.fill} />
        </g>
      ))}
    </g>
  </svg>
);

export default TreeLogo;
